module.exports = __webpack_public_path__ + "static/img/14000367.afae331a.png";